export default class Config {

    public static SITE_TITLE_PREFIX = 'Adaya';
    public static DEFAULT_RETURN_URL = '/ads-manager';
    public static ADMIN_TABLE_PAGE_SIZE = 50;
    public static ANIMATE_GRAPH_DURATION = 650;

}
